import React from "react";
import { RadioButtons } from "@narmi/design_system";
import { ContextForm } from "cerulean";

import styles from "./PrimaryChoiceContainer.module.scss";
import type { PrimaryChoiceConfig } from "./types";

type PrimaryChoiceContainerProps = {
  choiceConfig: PrimaryChoiceConfig | null;
};

const PrimaryChoiceContainer = ({
  choiceConfig
}: PrimaryChoiceContainerProps) => {
  if (!choiceConfig) {
    return null;
  }

  return (
    <div
      inert={choiceConfig.isHidden}
      aria-hidden={choiceConfig.isHidden}
      className={`${styles.accountTypeContainer} ${
        choiceConfig.isHidden ? styles.hidden : ""
      }`}
    >
      <div className={styles.content}>
        <div className="margin--bottom--l fontWeight--bold">
          {choiceConfig.label}
        </div>
        <ContextForm.Field required>
          <RadioButtons
            field={choiceConfig.field}
            name={choiceConfig.name}
            options={choiceConfig.options}
          />
        </ContextForm.Field>
      </div>
    </div>
  );
};

export default PrimaryChoiceContainer;
